module.exports = __webpack_public_path__ + "static/media/12.aec92166.jpeg";